export { default } from './categories-carousel-loading-state';
